import { ENDPOINTS, put } from '@/api/mainApi';
import { UserSession } from '@/interfaces/useraccount/userSession';

export class AuthRepository {
  constructor() {
  }

  public async assumeBusinessUserRole(businessId: number): Promise<UserSession> {
    return await put(`${ENDPOINTS.AUTH}/${ENDPOINTS.SESSIONS}/${ENDPOINTS.SWITCH}/${ENDPOINTS.BUSINESSES}/${businessId}`, {})
  }
}
